import ReactEcharts from 'echarts-for-react';
import {DspData} from './DspDashboard';

interface Props {
    pubDat: DspData[],
    style: {}
}

const DspDoughnutChart = (props: Props) => {

    let bids: number = 0
    let wins: number = 0
    let imps: number = 0
    props.pubDat.forEach(d => {
        bids += Number.parseInt(d.bid)
        wins += Number.parseInt(d.win)
        imps += Number.parseInt(d.impression)
    })

    const bidsChart = {value: bids, name: 'Bids', itemStyle: {color: '#42cbf5'}}
    const winsChart = {value: wins, name: 'Wins'}
    const impsChart = {value: imps, name: 'Impressions'}
    const losesChart = {value: bids - wins, name: 'Loses'}
    const noImp = {value: bids - imps, name: 'NoImp'}

    const labelData = [{name: 'Bids', itemStyle: {
            color: '#42cbf5'
        }}, 'Wins', 'Loses', 'Impressions', 'NoImp']

    const option = {
        title: {
            text: 'Wins and Impressions ratio',
            left: 'left'
        },
        tooltip: {
            trigger: 'item'
        },
        legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 20,
            bottom: 20,
            data: labelData
        },
        series: [
            {
                name: 'Win/Los',
                type: 'pie',
                radius: ['40%', '50%'],
                center: ['40%', '50%'],
                avoidLabelOverlap: false,
                label: {
                    formatter: '{b} {c}\n({d}%)',
                },
                data: [winsChart, losesChart]
            },
            {
                name: 'Imp/NoImp',
                type: 'pie',
                radius: ['12%', '38%'],
                center: ['40%', '50%'],
                avoidLabelOverlap: false,
                label: {
                    formatter: '{b} {c}\n({d}%)',
                    position: 'inside'
                },
                data: [impsChart, noImp]
            },
            {
                name: 'Bids',
                type: 'pie',
                radius: ['0%', '10%'],
                center: ['40%', '50%'],
                avoidLabelOverlap: false,
                label: {
                    formatter: '{c}',
                    position: 'center'
                },
                data: [bidsChart]
            }
        ]
    }

    return <ReactEcharts style={{margin: '10px 10px 10px 10px', ...props.style}} option={option}/>
}

export default DspDoughnutChart
